export default {
  http: {
    // 请求响应无数据时 向外抛出的错误
    ErrorNoneData: '请求出错，请稍后重试',
    // 成功提示语
    SuccessTip: '操作成功',
    // 失败提示语
    ErrorTip: '操作失败',
    // 错误的modal框语言
    ErrorModalTip: {
      // 普通提示 标题
      title: '浏览期间超时',
      // 底部按钮文字
      positiveText: '确定',
      // 登录超时时的提示
      loginTimoutContent: '您已经离开一段时间!',
      loginTimoutContentText: '为了保证您信息安全，我们暂时关闭了您正在做的事情。',
      // 网络错误时modal标题
      NetworkErrorTitle: '网络异常',
      // 网络错误时modal内容
      NetworkErrorContt: '请检查您的网络连接是否正常',
    },
    // 登录超时错误信息
    ErrorLoginTimeOutTip: '登录超时，请重新登录!',
    // 接口请求超时时的提示语
    ErrorApiTimeOut: '接口请求超时，请刷新页面重试!',
    status: {
      401: '用户没有权限（令牌、用户名、密码错误）!',
      403: '用户得到授权，但是访问是被禁止的。!',
      404: '网络请求错误，未找到该资源!',
      405: '网络请求错误，请求方法未允许!',
      408: '网络请求超时',
      500: '服务器错误,请联系管理员!',
      501: '网络未实现',
      502: '网络错误',
      503: '服务不可用，服务器暂时过载或维护!',
      504: '网络超时',
      505: 'http版本不支持该请求!',
    },
  },
};
